import {
  createContext,
  Dispatch,
  FC,
  SetStateAction,
  useContext,
  useState,
} from 'react'
import axios from 'lib/axiosConfig'
import { PlacesResponse, PlaceApi } from 'types/api/place'

interface PlacesContextTypes {
  selectedPlace?: PlaceApi
  setSelectedPlace: Dispatch<SetStateAction<PlaceApi | undefined>>
  getPlaces: (query: string) => Promise<PlacesResponse | null>
  isLoading: boolean
  error: boolean
}

const PlacesContext = createContext<PlacesContextTypes | null>(null)

const PlacesProvider: FC = ({ children }) => {
  const [selectedPlace, setSelectedPlace] = useState<PlaceApi>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<boolean>(false)

  const getPlaces = async (query: string): Promise<PlacesResponse | null> => {
    setIsLoading(true)
    try {
      const { data } = await axios.get<PlacesResponse>('/v1/places', {
        params: { q: query },
      })

      return data
    } catch (err) {
      setError(true)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <PlacesContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        selectedPlace,
        getPlaces,
        setSelectedPlace,
        isLoading,
        error,
      }}>
      {children}
    </PlacesContext.Provider>
  )
}

export const usePlaces = () => useContext(PlacesContext) as PlacesContextTypes

export default PlacesProvider
